import { type ComponentProps } from 'react'
import styled from 'styled-components'
import { Body } from '@shipt/design-system-typography'

type Props = ComponentProps<typeof Body> & {
  isVertical?: boolean
  children: React.ReactNode
}

export const ProductPromotionContainer = ({ isVertical, ...props }: Props) => {
  return (
    <Container
      {...props}
      isVertical={isVertical}
      concept="feedback"
      feedbackType="promotion"
      strong
      as="span"
    />
  )
}

const Container = styled(Body)<Props>`
  margin: ${({ isVertical }) => (isVertical ? '0' : '0.375rem 0')};
`
